import React from 'react'

export const padlockInCircle = color => (
    <svg width="24" height="24" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22" cy="22" r="22" fill="white" />
        <path
            d="M29.2861 15.937H28.0514V13.3836C28.0514 9.85985 25.2856 7 21.8778 7C18.4699 7 15.7042 9.85985 15.7042 13.3836V15.937H14.4694C13.1112 15.937 12 17.0861 12 18.4905V31.2577C12 32.6621 13.1112 33.8111 14.4694 33.8111H29.2861C30.6443 33.8111 31.7555 32.6621 31.7555 31.2577V18.4905C31.7555 17.0861 30.6443 15.937 29.2861 15.937ZM21.8778 27.4275C20.5196 27.4275 19.4083 26.2785 19.4083 24.8741C19.4083 23.4697 20.5196 22.3206 21.8778 22.3206C23.236 22.3206 24.3472 23.4697 24.3472 24.8741C24.3472 26.2785 23.236 27.4275 21.8778 27.4275ZM25.7054 15.937H18.0501V13.3836C18.0501 11.2004 19.7664 9.42577 21.8778 9.42577C23.9891 9.42577 25.7054 11.2004 25.7054 13.3836V15.937Z"
            fill={color}
        />
    </svg>
)
